import { render, staticRenderFns } from "./DeviceDevelop.vue?vue&type=template&id=645cd89c&scoped=true&"
import script from "./DeviceDevelop.vue?vue&type=script&lang=js&"
export * from "./DeviceDevelop.vue?vue&type=script&lang=js&"
import style0 from "./DeviceDevelop.vue?vue&type=style&index=0&id=645cd89c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645cd89c",
  null
  
)

export default component.exports